"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Pill = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Pill"));
var _events = require("../events");
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var CustomFieldsIcon = function CustomFieldsIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1.5H1.5v9H21v-9ZM1.5 0A1.5 1.5 0 0 0 0 1.5v9A1.5 1.5 0 0 0 1.5 12H21a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 21 0H1.5Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9V3h1.5v6H6Z"
  }));
};
CustomFieldsIcon.defaultProps = {
  viewBox: "0 0 23 12",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "icon": "CustomerMetadata__icon__1eFWZ",
  "dropdown-icon": "CustomerMetadata__dropdown-icon__1fowq",
  "dropdownIcon": "CustomerMetadata__dropdown-icon__1fowq",
  "metadata-item": "CustomerMetadata__metadata-item__1rfCM",
  "metadataItem": "CustomerMetadata__metadata-item__1rfCM",
  "metadata-item-wrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "metadataItemWrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "extendable": "CustomerMetadata__extendable__GmS9B",
  "editable": "CustomerMetadata__editable__2RE1j",
  "metadata": "CustomerMetadata__metadata__2OWHW",
  "popover": "CustomerMetadata__popover__ozLWy",
  "metadata-row": "CustomerMetadata__metadata-row__38kip",
  "metadataRow": "CustomerMetadata__metadata-row__38kip"
}; 
require('../CustomerMetadata.css');
var customFieldsStyles = {
  "container": "CustomFields__container__11u97",
  "categories": "CustomFields__categories__1XW9L",
  "select": "CustomFields__select__1hhAK",
  "category": "CustomFields__category__3yO7s",
  "name": "CustomFields__name__2-KNE",
  "values": "CustomFields__values__3W3bB",
  "pill": "CustomFields__pill__PiWUH",
  "pill-span": "CustomFields__pill-span__32N9P",
  "pillSpan": "CustomFields__pill-span__32N9P",
  "pill-tag": "CustomFields__pill-tag__3Sdfm",
  "pillTag": "CustomFields__pill-tag__3Sdfm"
}; 
require('./CustomFields.css');
var BOTTOM_LEFT_POSITION = 'bl';
var DOWN_POSITION = 'd';
var INVALID_DATE = 'Invalid Date';
var formatDate = function formatDate(term) {
  var date = new Date(term);
  if (date.toString() === INVALID_DATE) {
    return term;
  }
  return date.toLocaleString('en-US');
};
var CustomFields = function CustomFields(_ref) {
  var customFields = _ref.customFields;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var formatMetadataArray = function formatMetadataArray(metadataArray) {
    return metadataArray.sort(function (a, b) {
      return a.displayName.localeCompare(b.displayName);
    }).map(function (customField, index) {
      var values;
      if (customField.dataType === 'date') {
        values = [formatDate(customField.dateValue)];
      } else if (customField.dataType === 'enum') {
        values = customField.enumValue;
      } else if (customField.dataType === 'number') {
        values = [customField.numberValue];
      } else if (customField.dataType === 'number-list') {
        values = customField.numberListValue;
      } else if (customField.dataType === 'text') {
        values = [customField.textValue];
      } else if (customField.dataType === 'text-list') {
        values = customField.textListValue;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "view-asset-custom-field",
        className: customFieldsStyles.category
        // eslint-disable-next-line react/no-array-index-key
        ,
        key: "custom-fields-".concat(index)
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "view-asset-custom-field-name",
        className: customFieldsStyles.name
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "field-".concat(index)
      }, customField.displayName)), /*#__PURE__*/_react.default.createElement("div", {
        className: customFieldsStyles.values,
        "aria-live": "polite"
      }, values.map(function (value) {
        return /*#__PURE__*/_react.default.createElement(_Pill.default, {
          key: "custom-field-".concat(value),
          title: value,
          className: customFieldsStyles.pillTag,
          disabled: true
        }, value);
      })));
    });
  };
  var popoverModal = /*#__PURE__*/_react.default.createElement("section", {
    "data-test-id": "view-asset-categories",
    className: customFieldsStyles.container
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: "custom-fields-heading",
    className: "visually-hidden"
  }, "Custom Fields"), /*#__PURE__*/_react.default.createElement("div", {
    className: customFieldsStyles.categories
  }, formatMetadataArray(customFields)));
  var popoverContainer = _react.default.useRef(null);
  var content = /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "custom-fields-metadata-item-test",
    className: (0, _classnames.default)(styles.metadataItemWrapper, styles.extendable)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(CustomFieldsIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.metadataItem,
    id: "custom-fields-metadata-item"
  }, "Custom fields (".concat(customFields.length, ")")), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    "data-test-id": "drowpdown-arrow-icon",
    className: styles.dropdownIcon,
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(ArrowIcon, null)));
  if (!customFields.length) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "custom-fields-container",
    ref: popoverContainer
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    onOpen: function onOpen() {
      return trackEvent(_events.EVENT_TYPES.EXPANDING_CUSTOM_FIELDS);
    },
    anchorPosition: BOTTOM_LEFT_POSITION,
    popupPosition: DOWN_POSITION,
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.current;
    },
    content: popoverModal,
    closeOnClickInside: true
  }, content));
};
var _default = exports.default = CustomFields;
//# sourceMappingURL=CustomFields.js.map